import { SettingsLayout } from "@/features/settings/settings-layout";

export const Route = createFileRoute({
  component: SettingsLayout,
});
